export const APPEND_CONNECTION = 'APPEND_CONNECTION';
export const ADD_CONNECTION = 'ADD_CONNECTION';
export const REMOVE_CONNECTION = 'REMOVE_CONNECTION';
export const UPDATE_USED_CONNECTION = 'UPDATE_USED_CONNECTION';

export function appendConnection(connections) {
    return { type: APPEND_CONNECTION, connections };
}
export function addConnection(connections) {
    return { type: ADD_CONNECTION, connections };
}

export function removeConnection(connections) {
    return { type: REMOVE_CONNECTION, connections };
}

export function updateUsedConnection(connections) {
    return { type: UPDATE_USED_CONNECTION, connections };
}